import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Embedded24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 19C6 18.4477 6.44772 18 7 18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19ZM6 5.00002C6 4.44774 6.44772 4.00002 7 4.00002H17C17.5523 4.00002 18 4.44774 18 5.00002C18 5.55231 17.5523 6.00002 17 6.00002H7C6.44772 6.00002 6 5.55231 6 5.00002ZM2 14C2 15.6569 3.34315 17 5 17H19C20.6569 17 22 15.6569 22 14V10C22 8.34318 20.6569 7.00004 19 7.00004H5C3.34315 7.00004 2 8.34318 2 10V14ZM4.14999 13.5C4.14999 13.0306 4.53055 12.65 4.99999 12.65H8.99999C9.46944 12.65 9.84999 13.0306 9.84999 13.5C9.84999 13.9695 9.46944 14.35 8.99999 14.35H4.99999C4.53055 14.35 4.14999 13.9695 4.14999 13.5ZM4.14999 10.5C4.14999 10.0306 4.53055 9.65001 4.99999 9.65001H12C12.4694 9.65001 12.85 10.0306 12.85 10.5C12.85 10.9695 12.4694 11.35 12 11.35H4.99999C4.53055 11.35 4.14999 10.9695 4.14999 10.5ZM16 10C15.4477 10 15 10.4477 15 11V13C15 13.5523 15.4477 14 16 14H18C18.5523 14 19 13.5523 19 13V11C19 10.4477 18.5523 10 18 10H16Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
